var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4285f4"
    },
    d: "M23.745,12.27a13.9,13.9,0,0,0-.19-2.27h-11.3v4.51h6.47a5.571,5.571,0,0,1-2.4,3.58v3h3.86A11.733,11.733,0,0,0,23.745,12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34a853"
    },
    d: "M12.255,24a11.431,11.431,0,0,0,7.93-2.91l-3.86-3a7.239,7.239,0,0,1-4.07,1.16,7.167,7.167,0,0,1-6.73-4.96H1.545v3.09A11.982,11.982,0,0,0,12.255,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbbc05"
    },
    d: "M5.525,14.29A6.963,6.963,0,0,1,5.145,12a7.234,7.234,0,0,1,.38-2.29V6.62H1.545a11.864,11.864,0,0,0,0,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ea4335"
    },
    d: "M12.255,4.75a6.511,6.511,0,0,1,4.6,1.8l3.42-3.42A11.473,11.473,0,0,0,12.255,0,11.982,11.982,0,0,0,1.545,6.62l3.98,3.09A7.167,7.167,0,0,1,12.255,4.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f88c4faa20ede0e8a872cd6e05865be1.svg";
export { ForwardRef as ReactComponent };